import React, { useState, useEffect } from "react";

const InputText = ({
  name,
  value = "",
  placeholder,
  label,
  required = false,
  readOnly = false,
  fieldName = "This field",
  onChange,
  setInputTextError,
  className = "",
}) => {
  const [errMsg, setErrMsg] = useState("");

  const handleBlur = () => {
    const trimmedValue = String(value)?.trim();
    if (required && trimmedValue?.length === 0) {
      const requiredMessage = `${fieldName} is required.`;
      setErrMsg(requiredMessage);
      if (setInputTextError) {
        setInputTextError((previousState) => ({
          ...previousState,
          text: true,
        }));
      }
    } else {
      setErrMsg("");
      if (setInputTextError) {
        setInputTextError((previousState) => ({
          ...previousState,
          text: false,
        }));
      }
    }
  };
  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    onChange({ target: { name, value: inputValue } });
    if (errMsg) {
      setErrMsg("");
      if (setInputTextError) {
        setInputTextError((previousState) => ({
          ...previousState,
          text: false,
        }));
      }
    }
  };
  const handleKeyDown = (e) => {
  if (e.key === "Enter" && e.target.classList.contains("lab-value")) {
    e.preventDefault();

    const inputs = document.querySelectorAll(
      "input.lab-value:not([disabled]):not([readonly])"
    );
    const index = [...inputs].indexOf(e.target);
    inputs[index + 1]?.focus();
  }
};

  useEffect(() => {
    if (!errMsg && setInputTextError) {
      setInputTextError((previousState) => ({
        ...previousState,
        text: false,
      }));
    }
  }, [errMsg, setInputTextError]);

  return (
    <>
      <div className="form-group">
        <label htmlFor={name} className="col-form-label">
          {label}:
        </label>
        <input
          type="text"
          className={`form-control ${className}`}
          name={name}
          value={value ?? ""}
          onChange={handleInputChange}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          required={required}
          readOnly={readOnly}
        />
      </div>
      {!readOnly && <small className="text-danger">{errMsg}</small>}
    </>
  );
};

export default InputText;
